import axios from "../utilities/axiosInstance";
import {
  USER_LOGIN_REQUEST,
  USER_LOGIN_SUCCESS,
  USER_LOGIN_FAIL,
  USER_LOGOUT,
  USER_REGISTER_REQUEST,
  USER_REGISTER_SUCCESS,
  USER_REGISTER_FAIL,
} from "../constants/authConstants";

export const login = (email, password) => async (dispatch) => {
  console.log("Dispatching login action for:", email);
  try {
    dispatch({ type: USER_LOGIN_REQUEST });

    const { data } = await axios.post("/users/login", { email, password });
    console.log("Login successful, received data:", data);

    dispatch({ type: USER_LOGIN_SUCCESS, payload: data });

    // Persist userInfo in localStorage
    localStorage.setItem("userInfo", JSON.stringify(data));
  } catch (error) {
    console.error("Error in login action:", error);
    dispatch({
      type: USER_LOGIN_FAIL,
      payload: error.response?.data?.message || error.message,
    });
  }
};

/**
 * Logout action: Remove userInfo from localStorage and reset user state.
 */
export const logout = () => (dispatch) => {
  console.log("Dispatching logout action");
  // Remove from localStorage
  localStorage.removeItem("userInfo");
  // Dispatch the logout action to Redux
  dispatch({ type: USER_LOGOUT });
};

/**
 * Register action: Register a new user, then log them in.
 */
export const register = (name, email, password) => async (dispatch) => {
  console.log("Dispatching register action for:", email);
  try {
    dispatch({ type: USER_REGISTER_REQUEST });

    const { data } = await axios.post("/users/register", {
      name,
      email,
      password,
    });
    console.log("Registration successful, received data:", data);

    dispatch({ type: USER_REGISTER_SUCCESS, payload: data });
    // If you want them logged in right away:
    dispatch({ type: USER_LOGIN_SUCCESS, payload: data });

    localStorage.setItem("userInfo", JSON.stringify(data));
  } catch (error) {
    console.error("Error in register action:", error);
    dispatch({
      type: USER_REGISTER_FAIL,
      payload: error.response?.data?.message || error.message,
    });
  }
};

export const registerDeveloper =
  (name, email, password) => async (dispatch, getState) => {
    try {
      dispatch({ type: USER_REGISTER_REQUEST });
      console.log("Sending POST /users/register request with developer role");

      const {
        userLogin: { userInfo },
      } = getState();

      const config = {
        headers: {
          Authorization: `Bearer ${userInfo?.token}`,
        },
      };

      const { data } = await axios.post(
        "/users/register",
        { name, email, password, role: "developer" },
        config
      );

      console.log("Registration for developer successful:", data);
      dispatch({ type: USER_REGISTER_SUCCESS, payload: data });
      // We do not override localStorage userInfo, so the admin remains logged in
    } catch (error) {
      console.error("Error in registerDeveloper action:", error);
      dispatch({
        type: USER_REGISTER_FAIL,
        payload: error.response?.data?.message || error.message,
      });
    }
  };

export const changePassword =
  (userId, currentPassword, newPassword) => async (dispatch, getState) => {
    try {
      dispatch({ type: USER_CHANGE_PASSWORD_REQUEST });
      const {
        userLogin: { userInfo },
      } = getState();

      const config = {
        headers: {
          Authorization: `Bearer ${userInfo.token}`,
          "Content-Type": "application/json",
        },
      };

      const { data } = await axios.put(
        `/users/${userId}/password`,
        {
          currentPassword,
          newPassword,
        },
        config
      );

      dispatch({ type: USER_CHANGE_PASSWORD_SUCCESS, payload: data });
    } catch (error) {
      dispatch({
        type: USER_CHANGE_PASSWORD_FAIL,
        payload: error.response?.data?.message || error.message,
      });
    }
  };

// export const registerDeveloper =
//   (name, email, password) => async (dispatch, getState) => {
//     // We won't automatically log them in if we want the admin to stay logged in
//     try {
//       dispatch({ type: USER_REGISTER_REQUEST });
//       console.log("Sending POST /users/register request with developer role");

//       // We pass role: 'developer'
//       const { data } = await axios.post(
//         "/users/register",
//         {
//           name,
//           email,
//           password,
//           role: "developer",
//         },
//         {
//           headers: {
//             // optional if needed
//             Authorization: `Bearer ${getState().userLogin?.userInfo?.token}`,
//           },
//         }
//       );

//       console.log("Registration for developer successful:", data);
//       dispatch({ type: USER_REGISTER_SUCCESS, payload: data });

//       // Optionally store a success message in Redux or just handle success
//     } catch (error) {
//       console.error("Error in registerDeveloper action:", error);
//       dispatch({
//         type: USER_REGISTER_FAIL,
//         payload: error.response?.data?.message
//           ? error.response.data.message
//           : error.message,
//       });
//     }
//   };
